/* tslint:disable */
/* eslint-disable */
/**
 * BackOffice — Attributions par plateforme
 * Briques d\'un collaborateur par plateforme (override du compte, sémantique d\'override total avec repli sur le compte) et plafond délégable de la plateforme. Keyé par COLLABORATEUR (abpUserId) : un cabinet de N collaborateurs expose N lignes, et les collaborateurs d\'une corporate (sans ligne Courtier) sont adressables. Surface admin de l\'atelier des rôles + surface gouvernance du Portail Plateforme. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CollaborateurBriquesPlateformeDto
 */
export interface CollaborateurBriquesPlateformeDto {
    /**
     * 
     * @type {string}
     * @memberof CollaborateurBriquesPlateformeDto
     */
    abpUserId: string;
    /**
     * Ligne Courtier de la PM du collaborateur — partagée entre les collaborateurs d'un même cabinet, absente pour une corporate. Affichage/navigation seulement, jamais une clé d'adressage.
     * 
     * @type {string}
     * @memberof CollaborateurBriquesPlateformeDto
     */
    courtierId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollaborateurBriquesPlateformeDto
     */
    nom: string;
    /**
     * 
     * @type {string}
     * @memberof CollaborateurBriquesPlateformeDto
     */
    cabinet?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollaborateurBriquesPlateformeDto
     */
    email?: string | null;
    /**
     * Gérant de son cabinet — badge d'affichage.
     * @type {boolean}
     * @memberof CollaborateurBriquesPlateformeDto
     */
    isOwner: boolean;
    /**
     * 
     * @type {string}
     * @memberof CollaborateurBriquesPlateformeDto
     */
    nature?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CollaborateurBriquesPlateformeDto
     */
    natureLibelle?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CollaborateurBriquesPlateformeDto
     */
    briquesCompte: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CollaborateurBriquesPlateformeDto
     */
    briquesPlateforme?: Array<string> | null;
}

/**
 * Check if a given object implements the CollaborateurBriquesPlateformeDto interface.
 */
export function instanceOfCollaborateurBriquesPlateformeDto(value: object): value is CollaborateurBriquesPlateformeDto {
    if (!('abpUserId' in value) || value['abpUserId'] === undefined) return false;
    if (!('nom' in value) || value['nom'] === undefined) return false;
    if (!('isOwner' in value) || value['isOwner'] === undefined) return false;
    if (!('briquesCompte' in value) || value['briquesCompte'] === undefined) return false;
    return true;
}

export function CollaborateurBriquesPlateformeDtoFromJSON(json: any): CollaborateurBriquesPlateformeDto {
    return CollaborateurBriquesPlateformeDtoFromJSONTyped(json, false);
}

export function CollaborateurBriquesPlateformeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CollaborateurBriquesPlateformeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'abpUserId': json['abpUserId'],
        'courtierId': json['courtierId'] == null ? undefined : json['courtierId'],
        'nom': json['nom'],
        'cabinet': json['cabinet'] == null ? undefined : json['cabinet'],
        'email': json['email'] == null ? undefined : json['email'],
        'isOwner': json['isOwner'],
        'nature': json['nature'] == null ? undefined : json['nature'],
        'natureLibelle': json['natureLibelle'] == null ? undefined : json['natureLibelle'],
        'briquesCompte': json['briquesCompte'],
        'briquesPlateforme': json['briquesPlateforme'] == null ? undefined : json['briquesPlateforme'],
    };
}

export function CollaborateurBriquesPlateformeDtoToJSON(json: any): CollaborateurBriquesPlateformeDto {
    return CollaborateurBriquesPlateformeDtoToJSONTyped(json, false);
}

export function CollaborateurBriquesPlateformeDtoToJSONTyped(value?: CollaborateurBriquesPlateformeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'abpUserId': value['abpUserId'],
        'courtierId': value['courtierId'],
        'nom': value['nom'],
        'cabinet': value['cabinet'],
        'email': value['email'],
        'isOwner': value['isOwner'],
        'nature': value['nature'],
        'natureLibelle': value['natureLibelle'],
        'briquesCompte': value['briquesCompte'],
        'briquesPlateforme': value['briquesPlateforme'],
    };
}

